module.exports = __webpack_public_path__ + "static/media/golf1blur.65de98a3.jpg";